import React from 'react';
import SwiperCore, {Navigation} from 'swiper';
import {SwiperSlide} from 'swiper/react';
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';

import DaySchedule from 'components/DaySchedule';
import MySwiper from 'components/Shared/MySwiper';

import './ScheduleBoard.scss';

SwiperCore.use([Navigation]);

const ScheduleBoard = ({onSeanceClick, seancesByDay, title}) => {
  const swiperProps = {
    spaceBetween: 50,
    slidesPerView: 4,
    pagination: {clickable: true},
    scrollbar: {draggable: true},
    // onSwiper: swiper => console.log(swiper),
    // onSlideChange: () => console.log('slide change'),
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      460: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      660: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      850: {
        slidesPerView: 4,
        spaceBetween: 40,
      },
    },
  };

  return (
    <div className="grille">
      <MySwiper
        params={swiperProps}
        titleHeader={title}
        list={[...Array(seancesByDay.length).keys()].map(i => (
          <SwiperSlide key={i}>
            <DaySchedule seancesByDay={seancesByDay[i]} onSeanceClick={onSeanceClick} />
          </SwiperSlide>
        ))}
      />
    </div>
  );
};

export default ScheduleBoard;
